import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import './theme/terminal-theme.css'
import './theme/light-theme.css'
import { initSentry } from './config/sentry'

// Initialize Sentry error tracking
initSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
